import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./version.html"
})

export class Version implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];
  ngOnInit(): void {
    this.getData();
  }

  private getData(){
    this.http.getData(API.systemSetting_version).then(res=>{
      this.data=res.data;
    });
  }

  private editVersion(os:any){
    this.router.navigate(['index/version',os]);
  }



}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/systemSetting/version.component.ts